(() => {
  const allWidgets = document.querySelectorAll('[data-spice-barista]');
  const hasFullPageWidget = Array.from(allWidgets).some((widget) => widget.dataset.mode === 'full_page');

  if (hasFullPageWidget) {
    allWidgets.forEach((widget) => {
      if (widget.dataset.mode !== 'full_page') widget.remove();
    });
  }

  const widgets = document.querySelectorAll('[data-spice-barista]');
  if (!widgets.length) return;

  const createElement = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text) element.textContent = text;
    return element;
  };

  const shuffle = (items) => {
    const shuffled = [...items];
    for (let index = shuffled.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [shuffled[index], shuffled[swapIndex]] = [shuffled[swapIndex], shuffled[index]];
    }
    return shuffled;
  };

  const appendLinkedText = (parent, text, productUrl) => {
    const pattern = /\[\[([^\]|]+)\|([a-zA-Z0-9][a-zA-Z0-9-]*)\]\]/g;
    let lastIndex = 0;
    let match = pattern.exec(text);
    while (match) {
      if (match.index > lastIndex) parent.append(document.createTextNode(text.slice(lastIndex, match.index)));
      const link = createElement('a', '', match[1]);
      link.href = productUrl(match[2]);
      parent.append(link);
      lastIndex = pattern.lastIndex;
      match = pattern.exec(text);
    }
    if (lastIndex < text.length) parent.append(document.createTextNode(text.slice(lastIndex)));
  };

  widgets.forEach((widget) => {
    const endpoint = widget.dataset.endpoint;
    const cornerEndpoint = widget.dataset.cornerEndpoint;
    const storeSearchUrl = widget.dataset.storeSearchUrl || '/search';
    const searchEndpoint = widget.dataset.searchEndpoint || '';
    const mode = widget.dataset.mode || 'widget';
    const storageKey = widget.dataset.storageKey || 'spice-barista-history-v1';
    const historyLimit = Number(widget.dataset.historyLimit || 24);
    const panel = widget.querySelector('#SpiceBaristaPanel');
    const toggles = widget.querySelectorAll('[data-concierge-toggle]');
    const launcher = widget.querySelector('.spice-barista__launcher');
    const form = widget.querySelector('[data-concierge-form]');
    const input = widget.querySelector('[data-concierge-input]');
    const emailInput = widget.querySelector('[data-concierge-email]');
    const emailResponseInput = widget.querySelector('[data-concierge-email-response]');
    const marketingConsentInput = widget.querySelector('[data-concierge-marketing-consent]');
    const messagesContainer = widget.querySelector('[data-concierge-messages]');
    const promptsContainer = widget.querySelector('[data-concierge-prompts]');
    const clearButton = widget.querySelector('[data-concierge-clear]');
    const searchHelpLink = widget.querySelector('[data-concierge-search-link]');
    const searchNudge = widget.querySelector('[data-concierge-search-nudge]');
    const searchNudgeLink = widget.querySelector('[data-concierge-search-nudge-link]');
    const askAnywayButton = widget.querySelector('[data-concierge-ask-anyway]');
    const submitButton = form?.querySelector('button[type="submit"]');

    let threads = [];
    let activeThreadId = null;
    let pendingSearchQuery = '';

    const saveThreads = () => {
      try {
        localStorage.setItem(storageKey, JSON.stringify(threads.slice(0, historyLimit)));
      } catch {
        // Browser storage can be unavailable in private contexts.
      }
    };

    const loadThreads = () => {
      try {
        const saved = JSON.parse(localStorage.getItem(storageKey) || '[]');
        if (!Array.isArray(saved)) {
          threads = [];
          return;
        }

        if (saved.some((item) => item.query)) {
          threads = saved.filter((thread) => thread.id && thread.query).slice(0, historyLimit);
          activeThreadId = threads[0]?.id || null;
          return;
        }

        threads = [];
        for (let index = 0; index < saved.length; index += 1) {
          const message = saved[index];
          const next = saved[index + 1];
          if (message?.role !== 'user' || !message.content) continue;
          threads.unshift({
            id: `${Date.now()}-${index}`,
            query: message.content,
            answer: next?.role === 'assistant' ? next.content : '',
            recommendations: next?.recommendations || [],
            status: 'complete',
            createdAt: Date.now() - index,
          });
        }
        threads = threads.slice(0, historyLimit);
        activeThreadId = threads[0]?.id || null;
      } catch {
        threads = [];
      }
    };

    const productUrl = (handle) => `${window.shopUrl || window.location.origin}/products/${handle}`;
    const customerEmail = () => String(emailInput?.value || '').trim();

    const emailOptions = () => ({
      customerEmail: customerEmail(),
      emailResponseRequested: Boolean(emailResponseInput?.checked && customerEmail()),
      marketingConsent: Boolean(marketingConsentInput?.checked && customerEmail()),
    });

    const validateEmailOptions = () => {
      if (!emailInput) return true;
      emailInput.setCustomValidity('');
      if ((emailResponseInput?.checked || marketingConsentInput?.checked) && !customerEmail()) {
        emailInput.setCustomValidity('Enter your email address for this option.');
        emailInput.reportValidity();
        emailInput.focus();
        return false;
      }
      return true;
    };

    const productSearchUrl = (query = '') => {
      const url = new URL(storeSearchUrl, window.location.origin);
      if (query.trim()) url.searchParams.set('q', query.trim());
      return url.toString();
    };

    const updateSearchLinks = (query = '') => {
      if (searchHelpLink) searchHelpLink.href = productSearchUrl('');
      if (searchNudgeLink) searchNudgeLink.href = productSearchUrl(query);
    };

    const looksLikeProductSearch = (text) => {
      const query = text.trim();
      if (!query) return false;

      const lower = query.toLowerCase();
      const words = lower.split(/\s+/).filter(Boolean);
      const hasQuestionMark = query.includes('?');
      const cookingIntent = /\b(how|what can|recipe|recipes|use|using|cook|cooking|substitute|substitution|replace|make|with|for|pair|season|serve)\b/.test(lower);
      const productIntent = /\b(search|find|looking for|where is|where can i find|do you have|do you carry|carry|available|availability|in stock|stock|pickup|ship|shipping|price|cost|buy|order)\b/.test(lower);

      if (productIntent && !cookingIntent) return true;
      if (!hasQuestionMark && words.length === 1 && !cookingIntent) return true;

      return false;
    };

    const hideSearchNudge = () => {
      if (searchNudge) searchNudge.hidden = true;
      pendingSearchQuery = '';
    };

    const showSearchNudge = (query) => {
      pendingSearchQuery = query.trim();
      updateSearchLinks(pendingSearchQuery);
      if (searchNudge) searchNudge.hidden = false;
    };

    const resultUrl = (item) => item.url || (item.handle ? productUrl(item.handle) : '');

    const escapeRegExp = (value) => String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

    const highlightSearchText = (parent, text, query) => {
      const value = String(text || '');
      const terms = [
        String(query || '').trim(),
        ...String(query || '').toLowerCase().split(/[^a-z0-9]+/),
      ]
        .map((term) => term.trim())
        .filter((term) => term.length >= 2);
      const uniqueTerms = [...new Set(terms)].sort((a, b) => b.length - a.length);
      if (!value || !uniqueTerms.length) {
        parent.textContent = value;
        return;
      }
      const pattern = new RegExp(`(${uniqueTerms.map(escapeRegExp).join('|')})`, 'ig');
      value.split(pattern).forEach((part) => {
        if (!part) return;
        if (uniqueTerms.some((term) => part.toLowerCase() === term.toLowerCase())) {
          const mark = createElement('mark', 'spice-barista__search-mark', part);
          parent.append(mark);
        } else {
          parent.append(document.createTextNode(part));
        }
      });
    };

    const renderSearchGroup = (title, items = [], emptyText = '', query = '') => {
      const group = createElement('section', 'spice-barista__search-group');
      group.append(createElement('strong', 'spice-barista__search-heading', title));

      if (!items.length) {
        if (emptyText) group.append(createElement('p', 'spice-barista__search-empty', emptyText));
        return group;
      }

      const list = createElement('ul', 'spice-barista__search-results');
      items.forEach((item) => {
        const row = createElement('li', 'spice-barista__search-result');
        const href = resultUrl(item);
        if (href) {
          const link = createElement('a', 'spice-barista__search-title');
          link.href = href;
          highlightSearchText(link, item.title || item.question || href, query);
          row.append(link);
        } else {
          const title = createElement('span', 'spice-barista__search-title');
          highlightSearchText(title, item.title || item.question || 'Result', query);
          row.append(title);
        }
        if (item.excerpt) {
          const excerpt = createElement('span', 'spice-barista__search-excerpt');
          highlightSearchText(excerpt, item.excerpt, query);
          row.append(excerpt);
        }
        list.append(row);
      });
      group.append(list);
      return group;
    };

    const renderSearchResults = (results = {}) => {
      const wrapper = createElement('div', 'spice-barista__search-results-panel');
      const query = results.effectiveQuery || results.query || '';
      const total = (results.products || []).length + (results.articles || []).length + (results.corner || []).length;
      wrapper.append(
        createElement(
          'p',
          'spice-barista__search-summary',
          total ? `${total} result${total === 1 ? '' : 's'} found.` : `I searched products, articles, and Spice Barista answers for "${query || 'that'}" and did not find a match.`,
        ),
      );
      wrapper.append(renderSearchGroup('Products', results.products || [], 'No matching products found.', query));
      wrapper.append(renderSearchGroup('Articles', results.articles || [], 'Article search is not connected yet.', query));
      wrapper.append(renderSearchGroup('Spice Barista answers', results.corner || [], 'No matching Barista answers found.', query));
      if (query) {
        const fullSearch = createElement('a', 'spice-barista__search-title', 'View full search results');
        fullSearch.href = productSearchUrl(query);
        wrapper.append(fullSearch);
      }
      return wrapper;
    };

    const renderRecommendations = (recommendations = []) => {
      if (!recommendations.length) return null;

      const list = createElement('ul', 'spice-barista__recommendations');
      list.append(createElement('li', 'spice-barista__recommendation spice-barista__recommendation--heading', "Related Buck's picks"));
      recommendations.forEach((item) => {
        const row = createElement('li', 'spice-barista__recommendation');

        if (item.handle) {
          const link = createElement('a', '', item.title || item.handle);
          link.href = productUrl(item.handle);
          row.append(link);
        } else {
          row.append(document.createTextNode(item.title || 'Recommendation'));
        }

        if (item.reason) {
          row.append(document.createTextNode(`: ${item.reason}`));
        }
        list.append(row);
      });
      return list;
    };

    const renderCornerAnswer = (answer) => {
      const wrapper = createElement('div', 'spice-barista__corner-answer');
      const lines = String(answer || '').split(/\r?\n/);
      let list = null;

      lines.forEach((rawLine) => {
        const line = rawLine.trim();
        if (!line) {
          list = null;
          return;
        }

        const bullet = line.match(/^[-*]\s+(.+)/);
        if (bullet) {
          if (!list) {
            list = createElement('ul');
            wrapper.append(list);
          }
          const item = createElement('li');
          appendLinkedText(item, bullet[1], productUrl);
          list.append(item);
          return;
        }

        list = null;
        const paragraph = createElement('p');
        appendLinkedText(paragraph, line, productUrl);
        wrapper.append(paragraph);
      });

      return wrapper;
    };

    const renderPromptButtons = (entries = []) => {
      if (!promptsContainer || !entries.length) return;
      promptsContainer.innerHTML = '';
      entries.slice(0, 5).forEach((entry) => {
        const question = typeof entry === 'string' ? entry : entry.question;
        if (!question) return;
        const button = createElement('button', 'spice-barista__prompt', question);
        button.type = 'button';
        button.dataset.conciergePrompt = question;
        if (typeof entry === 'object' && entry.answer) {
          button.dataset.cornerQuestion = question;
          button.dataset.cornerAnswer = entry.answer;
          button.dataset.cornerRecommendations = JSON.stringify(entry.recommendations || []);
        }
        promptsContainer.append(button);
      });
    };

    const loadRecentPromptButtons = async () => {
      if (!cornerEndpoint || !promptsContainer) return;

      try {
        const url = new URL(cornerEndpoint, window.location.origin);
        if (!url.searchParams.has('limit')) url.searchParams.set('limit', '24');
        url.searchParams.set('_', String(Date.now()));
        const response = await fetch(url.toString(), { cache: 'no-store' });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'Questions could not be loaded.');
        renderPromptButtons(shuffle((result.entries || []).filter((entry) => entry.question && entry.answer)).slice(0, 3));
      } catch {
        // Keep the theme-configured fallback prompts if the Corner feed cannot load.
      }
    };

    const renderActiveThread = (thread) => {
      const article = createElement('article', 'spice-barista__active-thread');
      article.append(createElement('strong', 'spice-barista__message-label', thread.source === 'corner' ? 'Question' : 'You asked'));
      article.append(createElement('p', 'spice-barista__message-text', thread.query));

      const answer = createElement('div', 'spice-barista__answer');
      answer.append(createElement('strong', 'spice-barista__message-label', 'Spice Barista'));
      if (thread.status === 'pending') {
        answer.append(createElement('p', 'spice-barista__message-text', 'Thinking...'));
      } else if (thread.source === 'corner') {
        answer.append(renderCornerAnswer(thread.answer || 'No answer yet.'));
      } else if (thread.source === 'search') {
        answer.append(renderSearchResults(thread.searchResults || {}));
      } else {
        answer.append(createElement('p', 'spice-barista__message-text', thread.answer || 'No answer yet.'));
      }
      const recommendations = renderRecommendations(thread.recommendations);
      if (recommendations) answer.append(recommendations);
      article.append(answer);
      return article;
    };

    const showStoredCornerAnswer = (button) => {
      const query = button.dataset.cornerQuestion || button.dataset.conciergePrompt || button.textContent || '';
      const answer = button.dataset.cornerAnswer || '';
      if (!query.trim() || !answer.trim()) return false;

      let recommendations = [];
      try {
        recommendations = JSON.parse(button.dataset.cornerRecommendations || '[]');
      } catch {
        recommendations = [];
      }

      const existing = threads.find((thread) => thread.source === 'corner' && thread.query === query);
      const thread =
        existing ||
        {
          id: `corner-${Date.now()}-${Math.random().toString(16).slice(2)}`,
          query,
          answer,
          recommendations,
          status: 'complete',
          source: 'corner',
          createdAt: Date.now(),
        };

      if (!existing) {
        threads.unshift(thread);
        threads = threads.slice(0, historyLimit);
      }
      activeThreadId = thread.id;
      saveThreads();
      renderMessages();
      return true;
    };

    const renderThreadList = () => {
      const inactiveThreads = threads.filter((thread) => thread.id !== activeThreadId);
      if (!inactiveThreads.length) return null;

      const list = createElement('div', 'spice-barista__thread-list');
      list.append(createElement('strong', 'spice-barista__thread-list-label', 'Your recent questions'));
      inactiveThreads.slice(0, 4).forEach((thread) => {
        const button = createElement('button', 'spice-barista__thread');
        button.type = 'button';
        button.dataset.threadId = thread.id;
        button.setAttribute('aria-pressed', 'false');
        button.append(createElement('span', 'spice-barista__thread-question', thread.query));
        list.append(button);
      });
      return list;
    };

    const renderMessages = () => {
      messagesContainer.innerHTML = '';
      const activeThread = threads.find((thread) => thread.id === activeThreadId) || threads[0];
      widget.classList.toggle('spice-barista--has-active-thread', Boolean(activeThread));
      if (activeThread) {
        activeThreadId = activeThread.id;
        messagesContainer.append(renderActiveThread(activeThread));
      }
      const threadList = renderThreadList();
      if (threadList) messagesContainer.append(threadList);

      messagesContainer.querySelectorAll('[data-thread-id]').forEach((button) => {
        button.addEventListener('click', () => {
          activeThreadId = button.dataset.threadId;
          renderMessages();
        });
      });
    };

    const setPanelOpen = (open) => {
      panel.hidden = !open;
      launcher?.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) window.requestAnimationFrame(() => input?.focus());
    };

    const submitSearch = async (text) => {
      const query = text.trim();
      if (!query) return;
      if (!searchEndpoint) {
        window.location.href = productSearchUrl(query);
        return;
      }
      hideSearchNudge();

      const thread = {
        id: `search-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        query,
        answer: '',
        recommendations: [],
        searchResults: { products: [], articles: [], corner: [] },
        status: 'pending',
        source: 'search',
        createdAt: Date.now(),
      };
      threads.unshift(thread);
      threads = threads.slice(0, historyLimit);
      activeThreadId = thread.id;
      saveThreads();
      renderMessages();
      input.value = '';
      updateSearchLinks('');
      submitButton.disabled = true;

      try {
        const response = await fetch(searchEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query, source: mode, productLimit: 4, articleLimit: 3, cornerLimit: 3 }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'Search failed.');
        thread.searchResults = result;
        thread.status = 'complete';
      } catch (error) {
        thread.answer = error.message || 'Search failed.';
        thread.searchResults = { products: [], articles: [], corner: [] };
        thread.status = 'error';
        thread.source = 'assistant';
      } finally {
        threads = threads.slice(0, historyLimit);
        saveThreads();
        renderMessages();
        submitButton.disabled = false;
      }
    };

    const submitQuestion = async (text) => {
      const query = text.trim();
      if (!query || !endpoint) return;
      if (!validateEmailOptions()) return;
      hideSearchNudge();

      const thread = {
        id: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
        query,
        answer: '',
        recommendations: [],
        status: 'pending',
        createdAt: Date.now(),
      };
      threads.unshift(thread);
      threads = threads.slice(0, historyLimit);
      activeThreadId = thread.id;
      saveThreads();
      renderMessages();
      input.value = '';
      updateSearchLinks('');
      submitButton.disabled = true;

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            query,
            mode,
            ...emailOptions(),
            messages: threads
              .filter((item) => item.status === 'complete' && item.answer)
              .reverse()
              .flatMap((item) => [
                { role: 'user', content: item.query },
                { role: 'assistant', content: item.answer },
              ])
              .slice(-8)
          }),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error || 'The advisor could not answer just now.');

        thread.answer = result.reply || '';
        thread.recommendations = result.recommendations || [];
        thread.status = 'complete';
      } catch (error) {
        thread.answer = error.message || 'The advisor could not answer just now.';
        thread.recommendations = [];
        thread.status = 'error';
      } finally {
        threads = threads.slice(0, historyLimit);
        saveThreads();
        renderMessages();
        submitButton.disabled = false;
      }
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', () => setPanelOpen(panel.hidden));
    });

    promptsContainer?.addEventListener('click', (event) => {
      const button = event.target.closest('[data-concierge-prompt]');
      if (!button) return;
      setPanelOpen(true);
      if (showStoredCornerAnswer(button)) return;
      submitQuestion(button.dataset.conciergePrompt || button.textContent || '');
    });

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const query = input.value || '';
      if (looksLikeProductSearch(query)) {
        submitSearch(query);
        return;
      }
      submitQuestion(query);
    });

    input?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault();
        const query = input.value || '';
        if (looksLikeProductSearch(query)) {
          submitSearch(query);
          return;
        }
        submitQuestion(query);
      }
    });

    input?.addEventListener('input', () => {
      updateSearchLinks(input.value || '');
      if (!searchNudge?.hidden && !looksLikeProductSearch(input.value || '')) hideSearchNudge();
    });

    askAnywayButton?.addEventListener('click', () => {
      const query = pendingSearchQuery || input?.value || '';
      submitQuestion(query);
    });

    clearButton?.addEventListener('click', () => {
      threads = [];
      activeThreadId = null;
      saveThreads();
      updateSearchLinks('');
      renderMessages();
      input?.focus();
    });

    loadThreads();
    updateSearchLinks(input?.value || '');
    loadRecentPromptButtons();
    renderMessages();
  });
})();
